export const LOGOS = {
    All: "/img/logo.png",
    maxicus: "/img/Maxicus_logo.png",
    kochar: "/img/logo.png",
    igzy: "/img/igzy.png",
    kochiva: "/img/kochiva.png",
    kocharsoft: "/img/kocharsoft.png",
  };